import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { CommunityDetailsComponent } from "./pages/community-details/community-details.component";
import { CommunityListComponent } from "./pages/community-list/community-list.component";
import { CommunityRoutingModule } from "./community-routing.module";
import { CommunityComponent } from "./community.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { CustomDateAdapter } from "src/app/core/services/uitls/custom-date.util";
import { MATERIAL_DATEPICKER_FORMATS } from "src/app/shared/global/date-formate-constant";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ViewCommunityComponent } from './pages/view-community/view-community.component';
import { LinkCardComponent } from "./components/link-card/link-card.component";

@NgModule({
  declarations: [
    CommunityComponent,
    CommunityDetailsComponent,
    CommunityListComponent,
    ViewCommunityComponent,
    LinkCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    CommunityRoutingModule,
    NgSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule
  ],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATEPICKER_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'ar-eg' },
  ],
})

export class CommunityModule {}
